import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { User } from '../../../../interfaces';
import { TranslationService } from '../../../../services/translation.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'contact-info',
  imports: [InputTextModule,TranslatePipe],
  templateUrl: './contact-info.component.html',
  styleUrl: './contact-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactInfoComponent {
  user: InputSignal<User> = input.required();
  translateService = inject(TranslationService);
}
